<template>
  <div>
    <div class="content">
      <div class="container text-center">
        <div style="margin-top: 100px">
          <img src="../assets/logo.png" alt="Congregação Cristã no Brasil" class="img-fluid" style="max-width: 128px;">
          <h3 class="font-weight-bold mt-3 mb-1">Você está offline</h3>
          <p>Acesse a internet para baixar os dados do aplicativo.</p>
          <a href="/" class="btn btn-outline-primary">Atualizar</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import BottonBar from "../components/BottonBar";
  import TopBar from "@/components/TopBar";

  export default {
    name: 'P404',
    components: {TopBar, BottonBar}
  }
</script>